webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(15);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _App = __webpack_require__(49);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vm = new _vue2.default({
	  el: '#app',
	  store: _store2.default,
	  template: '<App/>',
	  components: { App: _App2.default }
	
	});

/***/ },

/***/ 12:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Todolist = __webpack_require__(50);
	
	var _Todolist2 = _interopRequireDefault(_Todolist);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    Todolist: _Todolist2.default
	  },
	  data: function data() {
	    return {
	      usuarioActivo: null
	    };
	  },
	
	  created: function created() {
	    var store = this.$store.commit;
	    var vm = this;
	
	    var config = {
	      apiKey: "AIzaSyDBSnVdwqjs0oKQpfVv3j5bPoggqM8qqHw",
	      authDomain: "todolist-lab.firebaseapp.com",
	      databaseURL: "https://todolist-lab.firebaseio.com",
	      storageBucket: "todolist-lab.appspot.com",
	      messagingSenderId: "404056089437"
	    };
	    this.$firebaseApp.init(config);
	    store('setfirebaseDB', this.$firebaseApp.db());
	    store('setfirebaseAuth', this.$firebaseApp.auth());
	    store('setfirebaseProviderG', this.$firebaseApp.providerG());
	
	    this.$store.state.auth.onAuthStateChanged(function (user) {
	      if (user) {
	        store('setUsuarioActivo', user);
	        vm.usuarioActivo = user;
	      } else {
	        store('setUsuarioActivo', null);
	        vm.usuarioActivo = null;
	      }
	    });
	  },
	  methods: {
	    conectar: function conectar() {
	      this.$store.state.auth.signInWithPopup(this.$store.state.provider).catch(function (error) {
	        console.log('Errores: ' + error);
	      });
	    },
	    desconectar: function desconectar() {
	      this.$store.state.auth.signOut();
	    }
	  }
	};

/***/ },

/***/ 13:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'todolist',
	  created: function created() {
	    var _this = this;
	
	    this.$store.state.db.ref('tareas/').on('value', function (snapshot) {
	      _this.tareas = [];
	      var objeto = snapshot.val();
	      for (var propiedad in objeto) {
	        _this.tareas.unshift({
	          '.key': propiedad,
	          completado: objeto[propiedad].completado,
	          titulo: objeto[propiedad].titulo,
	          nombre: objeto[propiedad].nombre,
	          avatar: objeto[propiedad].avatar,
	          uid: objeto[propiedad].uid
	        });
	      }
	    });
	  },
	  data: function data() {
	    return {
	      nuevaTarea: null,
	      editandoTarea: null,
	      tareas: [],
	      db: {},
	      uid: null
	    };
	  },
	
	  props: ['usuarioActivo', 'autentificado'],
	  methods: {
	    agregarTarea: function agregarTarea(tarea) {
	      var usuario = this.usuarioActivo;
	      console.log(usuario);
	      if (this.$store.state.autentificado) {
	        this.$store.state.db.ref('tareas/').push({
	          titulo: tarea,
	          completado: false,
	          nombre: usuario.displayName,
	          avatar: usuario.photoURL,
	          uid: usuario.uid
	        });
	
	        this.nuevaTarea = '';
	      }
	    },
	    editarTarea: function editarTarea(tarea) {
	      this.$store.state.db.ref('tareas/' + tarea['.key']).update({
	        titulo: tarea.titulo
	      });
	    },
	    actualizarEstadoTarea: function actualizarEstadoTarea(estado, tarea) {
	      this.$store.state.db.ref('tareas/' + tarea['.key']).update({
	        completado: estado ? true : false
	      });
	    },
	    eliminarTarea: function eliminarTarea(tarea) {
	      this.$store.state.db.ref('tareas/' + tarea['.key']).remove();
	    }
	  }
	};

/***/ },

/***/ 14:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _defineProperties = __webpack_require__(16);
	
	var _defineProperties2 = _interopRequireDefault(_defineProperties);
	
	exports.default = function (Vue) {
		Vue.firebaseAPP = FirebasePlugin;
	
		(0, _defineProperties2.default)(Vue.prototype, {
			$firebaseApp: {
				get: function get() {
					return Vue.firebaseAPP;
				}
			}
		});
	};
	
	var _firebase = __webpack_require__(45);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FirebasePlugin = {
		init: function init(config) {
			if (_firebase2.default.apps.length === 0) _firebase2.default.initializeApp(config);
	
			return _firebase2.default;
		},
		db: function db() {
			var fb = _firebase2.default;
			return fb.database();
		},
		auth: function auth() {
			var fb = _firebase2.default;
			return fb.auth();
		},
		providerG: function providerG() {
			var provider = new _firebase2.default.auth.GoogleAuthProvider();
			return provider;
		}
	};

/***/ },

/***/ 15:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(53);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _firebaseApp = __webpack_require__(14);
	
	var _firebaseApp2 = _interopRequireDefault(_firebaseApp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	_vue2.default.use(_firebaseApp2.default);
	
	exports.default = new _vuex2.default.Store({
	  state: {
	    currentUser: {},
	    db: {},
	    auth: {},
	    provider: {},
	    autentificado: false,
	    usuarioActivo: null
	  },
	  mutations: {
	    setfirebaseDB: function setfirebaseDB(state, firebaseApp) {
	      state.db = firebaseApp;
	    },
	    setfirebaseAuth: function setfirebaseAuth(state, firebaseApp) {
	      state.auth = firebaseApp;
	    },
	    setfirebaseProviderG: function setfirebaseProviderG(state, firebaseApp) {
	      state.provider = firebaseApp;
	    },
	    setUsuarioActivo: function setUsuarioActivo(state, user) {
	      if (user != null) {
	        state.autentificado = true;
	      } else {
	        state.autentificado = false;
	      }
	    }
	  }
	});

/***/ },

/***/ 41:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 42:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 49:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(42)
	
	/* script */
	__vue_exports__ = __webpack_require__(12)
	
	/* template */
	var __vue_template__ = __webpack_require__(52)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 50:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(41)
	
	/* script */
	__vue_exports__ = __webpack_require__(13)
	
	/* template */
	var __vue_template__ = __webpack_require__(51)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 51:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;
	  return _vm._h('div', {
	    staticClass: "todolist"
	  }, [_vm._h('form', {
	    staticClass: "form",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.agregarTarea(_vm.nuevaTarea)
	      }
	    }
	  }, [_vm._h('div', {
	    staticClass: "input-group"
	  }, [_vm._h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nuevaTarea),
	      expression: "nuevaTarea"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "required": "",
	      "type": "text",
	      "placeholder": "Edite una tarea..."
	    },
	    domProps: {
	      "value": _vm._s(_vm.nuevaTarea)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.nuevaTarea = $event.target.value
	      }
	    }
	  }), " ", _vm._h('span', {
	    staticClass: "input-group-btn"
	  }, [_vm._h('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "disabled": !this.$store.state.autentificado,
	      "type": "submit"
	    }
	  }, ["Agregar tarea"])])])]), " ", _vm._m(0), " ", _vm._l((_vm.tareas), function(tarea, index) {
	    return _vm._h('div', {
	      staticClass: "card"
	    }, [_vm._h('div', {
	      staticClass: "card-block"
	    }, [_vm._h('h5', {
	      staticClass: " card-title",
	      class: {
	        completado: tarea.completado
	      }
	    }, [_vm._h('img', {
	      staticClass: "avatar",
	      staticStyle: {
	        "margin.right": "15px",
	        "border-radius": "4px"
	      },
	      attrs: {
	        "src": tarea.avatar,
	        "height": "32px",
	        "width": "32px"
	      }
	    }), "\n        " + _vm._s(tarea.titulo) + "\n        ", _vm._h('small', {
	      staticStyle: {
	        "font-size": "12px"
	      }
	    }, ["(" + _vm._s(tarea.nombre) + ")"])]), " ", _vm._h('input', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.editandoTarea === index),
	        expression: "editandoTarea===index"
	      }, {
	        name: "model",
	        rawName: "v-model",
	        value: (tarea.titulo),
	        expression: "tarea.titulo"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": _vm._s(tarea.titulo)
	      },
	      on: {
	        "blur": function($event) {
	          _vm.editandoTarea = null, _vm.editarTarea(tarea)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          tarea.titulo = $event.target.value
	        }
	      }
	    }), " ", (_vm.usuarioActivo != null) ? _vm._h('div', [(tarea.uid == _vm.usuarioActivo.uid) ? _vm._h('div', {
	      staticClass: "float-xs-right"
	    }, [_vm._h('a', {
	      staticClass: "btn btn-primary btn-sm",
	      attrs: {
	        "href": "#"
	      },
	      on: {
	        "click": function($event) {
	          _vm.editandoTarea = index
	        }
	      }
	    }, [_vm._m(1, true)]), " ", _vm._h('a', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.editandoTarea === index),
	        expression: "editandoTarea===index"
	      }],
	      staticClass: "btn btn-outline-primary btn-sm",
	      attrs: {
	        "href": "#"
	      },
	      on: {
	        "click": function($event) {
	          _vm.editandoTarea = null, _vm.editarTarea(tarea)
	        }
	      }
	    }, [_vm._m(2, true)]), " ", _vm._h('a', {
	      staticClass: "btn btn-success btn-sm",
	      attrs: {
	        "href": "#"
	      },
	      on: {
	        "click": function($event) {
	          _vm.actualizarEstadoTarea(true, tarea)
	        }
	      }
	    }, [_vm._m(3, true)]), " ", _vm._h('a', {
	      staticClass: "btn btn-outline-success btn-sm",
	      attrs: {
	        "href": "#"
	      },
	      on: {
	        "click": function($event) {
	          _vm.actualizarEstadoTarea(false, tarea)
	        }
	      }
	    }, [_vm._m(4, true)]), " ", _vm._h('a', {
	      staticClass: "btn btn-danger btn-sm",
	      attrs: {
	        "href": "#"
	      },
	      on: {
	        "click": function($event) {
	          _vm.eliminarTarea(tarea)
	        }
	      }
	    }, [_vm._m(5, true)])]) : _vm._e()]) : _vm._e()])])
	  }), " ", _vm._h('pre', [_vm._s(_vm.$data)])])
	},staticRenderFns: [function (){var _vm=this;
	  return _vm._h('br')
	},function (){var _vm=this;
	  return _vm._h('i', {
	    staticClass: "fa fa-pencil",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })
	},function (){var _vm=this;
	  return _vm._h('i', {
	    staticClass: "fa fa-floppy-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })
	},function (){var _vm=this;
	  return _vm._h('i', {
	    staticClass: "fa fa-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })
	},function (){var _vm=this;
	  return _vm._h('i', {
	    staticClass: "fa fa-undo",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })
	},function (){var _vm=this;
	  return _vm._h('i', {
	    staticClass: "fa fa-trash",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })
	}]}

/***/ },

/***/ 52:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;
	  return _vm._h('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_vm._h('div', {
	    staticClass: "container"
	  }, [_vm._h('div', {
	    staticClass: "header clearfix"
	  }, [_vm._h('nav', [_vm._h('ul', {
	    staticClass: "nav nav-pills float-xs-right"
	  }, [(!this.$store.state.autentificado) ? _vm._h('li', {
	    staticClass: "nav-item"
	  }, [_vm._h('a', {
	    staticClass: "nav-link",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.conectar($event)
	      }
	    }
	  }, ["Conectar"])]) : _vm._e(), " ", (this.$store.state.autentificado) ? _vm._h('li', {
	    staticClass: "nav-item dropdown"
	  }, [_vm._h('a', {
	    staticClass: "nav-link dropdown-toggle",
	    attrs: {
	      "data-toggle": "dropdown",
	      "href": "#",
	      "role": "button",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, [_vm._h('img', {
	    staticClass: "rounded",
	    attrs: {
	      "src": _vm.usuarioActivo.photoURL,
	      "height": "32px",
	      "width": "32px",
	      "alt": "..."
	    }
	  }), "\n              " + _vm._s(_vm.usuarioActivo.displayName) + "\n            "]), " ", _vm._h('div', {
	    staticClass: "dropdown-menu ",
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._m(0), " ", _vm._m(1), " ", _vm._h('a', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.desconectar($event)
	      }
	    }
	  }, [_vm._m(2), " Salir"])])]) : _vm._e()])]), " ", _vm._m(3)]), " ", _vm._h('todolist', {
	    attrs: {
	      "autentificado": _vm.autentificado,
	      "usuarioActivo": _vm.usuarioActivo
	    }
	  }), " ", _vm._m(4)]), " "])
	},staticRenderFns: [function (){var _vm=this;
	  return _vm._h('a', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "href": "javascript:void(0)"
	    }
	  }, [_vm._h('p'), " ", _vm._h('p', ["Perfil del usuario"])])
	},function (){var _vm=this;
	  return _vm._h('div', {
	    staticClass: "dropdown-divider"
	  })
	},function (){var _vm=this;
	  return _vm._h('i', {
	    staticClass: "fa fa-sign-out",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })
	},function (){var _vm=this;
	  return _vm._h('h3', {
	    staticClass: "text-muted"
	  }, ["Todolist \n      ", _vm._h('a', {
	    staticClass: "btn btn-sm btn-link",
	    attrs: {
	      "href": "https://github.com/jqEmprendedorVE/todolist-vuejs",
	      "target": "_blank"
	    }
	  }, [_vm._h('i', {
	    staticClass: "fa fa-github-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), " Clone this App"])])
	},function (){var _vm=this;
	  return _vm._h('footer', {
	    staticClass: "footer"
	  }, [_vm._h('p', ["© Company 2014"])])
	}]}

/***/ }

});


// WEBPACK FOOTER //
// static/js/app.3ace955f0107de598dd2.js